import { connect } from 'react-redux';

import { ServerImage as BaseServerImage } from '@mews-distributor/common';
import { getImageBaseUrl } from '../../modules/configuration/selectors';

export const ServerImage = connect((state) => ({
    // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
    imageBaseUrl: getImageBaseUrl(state),
}))(BaseServerImage);
